import { Country } from 'react-phone-number-input';
import { InvalidFormat } from '../exceptions/InvalidFormat';
import { isValidPhoneNumber as libIsValidPhoneNumber } from 'libphonenumber-js';
import { parsePhoneNumber } from 'react-phone-number-input';
import { getCountries, getCountryCallingCode } from 'react-phone-number-input/input';

export class PhoneNumber {
  public value: string;

  constructor(value: string) {
    if (this.isValidPhoneNumber(value)) {
      this.value = value;
    } else {
      throw new InvalidFormat(`PhoneNumber is invalid format. ${value}`);
    }
  }

  // isValidPhoneNumber(value: string): boolean {
  //   //080-1234-5678
  //   //080 1234 5678
  //   const regex1 = /0[0-9]0(-| )[0-9]{4}(-| )[0-9]{4}$/;
  //   //08012345678
  //   const regex2 = /0[0-9]0[0-9]{8}$/;
  //   //0312345678
  //   const regex3 = /0[0-9][0-9]{8}$/;
  //   //03-1234-5678
  //   //03 1234 5678
  //   const regex4 = /0[0-9](-| )[0-9]{4}(-| )[0-9]{4}$/;
  //   return regex1.test(value) || regex2.test(value) || regex3.test(value) || regex4.test(value);
  // }
  isValidPhoneNumber(value: string): boolean {
    return libIsValidPhoneNumber(value);
  }
}

export const isTaiwanPhone = (phoneNumber: string): boolean => {
  try {
    const parsedPhoneNumber = parsePhoneNumber(phoneNumber);
    return parsedPhoneNumber?.country === 'TW';
  } catch {
    return false;
  }
};

export const countryOptions: { value: string; countryCode: Country; flag: string }[] =
  getCountries()
    //.filter((country) => country !== 'JP') // 日本（JP）を除外 //TODO 一時的に日本も許可
    .map((country) => ({
      value: `+${getCountryCallingCode(country as Country)}`,
      countryCode: country as Country,
      flag: `fi fi-${country.toLowerCase()}`,
    }))
    .sort((a, b) => a.countryCode.localeCompare(b.countryCode));
